module.exports = __webpack_public_path__ + "static/img/game-head-tlxxl.eeebed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game/game-head-tlxxl.png
// module id = h2PJ
// module chunks = 1